<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="inspTimingDtlName"
    item-value="inspTimingDtlCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    :exceptCdList="exceptCdList"
    :exceptComparator="exceptComparator"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'InspTimingDtlInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0437')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    companyCatCd: {
      type: String,
      required: false,
      default: '',
    },
    inspTimingCd: {
      type: String,
      required: false,
      default: '',
    },
    inspClassCd: {
      type: String,
      required: false,
      default: '',
    },
    inspCat2Cd: {
      type: String,
      required: false,
      default: '',
    },
    exceptCdList: {
      // 選択肢から除外したいIDのリスト
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
  },

  watch: {
    inspCat2Cd() {
      this.search()
    },
    inspTimingCd() {
      this.search()
    },
  },

  methods: {
    exceptComparator(item, except) {
      return item.inspTimingDtlCd == except.inspTimingDtlCd
    },
    async search() {
      this.loading = true
      try {
        const params = {
          companyCatCd: this.companyCatCd,
          inspTimingCd: this.inspTimingCd,
          inspClassCd: this.inspClassCd,
          inspCat2Cd: this.inspCat2Cd,
          validOnly: this.validOnly,
        }
        this.items = await API.get('/master/inspTimingDtls', params)
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0437') })))
      } finally {
        this.loading = false
      }
    },
  },

  mounted() {
    this.search()
  },
}
</script>
